import { z } from "zod";
import { ClaimableRoleSchema, ParticipantTypeSchema, RoleSchema, } from "./common.js";
/**
 * A reference to anyone (or anything) that can appear in a group's expenses.
 * `id` is the stable server-assigned UUID expense `payments` and item splits
 * reference; it survives a guest → user claim.
 */
export const ParticipantSchema = z.strictObject({
    id: z.string().uuid(),
    type: ParticipantTypeSchema,
    /** Set only on `USER` participants. */
    userId: z.string().uuid().optional(),
    displayName: z.string().min(1).max(64),
    role: RoleSchema,
    /** Set only on participants who started as `GUEST` and were later claimed. */
    claimedAt: z.string().datetime().optional(),
});
export const AddParticipantRequestSchema = z.discriminatedUnion("type", [
    z.strictObject({
        type: z.literal("GUEST"),
        displayName: z.string().min(1).max(64),
        role: RoleSchema.default("MEMBER"),
    }),
    z.strictObject({
        type: z.literal("USER"),
        userId: z.string().uuid(),
        role: RoleSchema.default("MEMBER"),
    }),
]);
export const UpdateParticipantRequestSchema = z.strictObject({
    displayName: z.string().min(1).max(64).optional(),
    role: RoleSchema.optional(),
});
/** Roles a join request can propose / be approved with. */
export { ClaimableRoleSchema };
